const BASE_URL =
  process.env.NEXT_PUBLIC_MARKETING_SITE ||
  "https://torenindex.com";

export const learningLinks = {
  // Legacy stages
  discovery: [
    {
      href: `${BASE_URL}/learning-center/ai-discovery-content`,
      label: "Improve discovery visibility →",
      external: true
    },
    {
      href: `${BASE_URL}/learning-center/content-clustering`,
      label: "Build content clusters →",
      external: true
    },
    {
      href: `${BASE_URL}/learning-center/schema-for-ai`,
      label: "Add structured data (schema) →",
      external: true
    }
  ],

  recommendation: [
    {
      href: `${BASE_URL}/learning-center/ai-recommendation-content`,
      label: "Improve recommendation inclusion →",
      external: true
    },
    {
      href: `${BASE_URL}/learning-center/authority-signals`,
      label: "Strengthen authority signals →",
      external: true
    },
    {
      href: `${BASE_URL}/learning-center/use-cases-and-proof`,
      label: "Add use cases & proof →",
      external: true
    }
  ],

  comparison: [
    {
      href: `${BASE_URL}/learning-center/ai-comparison-content`,
      label: "Win comparison queries →",
      external: true
    },
    {
      href: `${BASE_URL}/learning-center/comparison-pages`,
      label: "Create comparison pages →",
      external: true
    },
    {
      href: `${BASE_URL}/learning-center/competitive-positioning`,
      label: "Improve competitive positioning →",
      external: true
    }
  ],

  // Competitive 72 buyer-journey stages
  category_discovery: [
    {
      href: `${BASE_URL}/learning-center/improve-ai-buyer-journey-visibility`,
      label: "Improve buyer journey visibility →",
      external: true
    },
    {
      href: `${BASE_URL}/learning-center/ai-discovery-content`,
      label: "Improve discovery visibility →",
      external: true
    },
    {
      href: `${BASE_URL}/learning-center/content-clustering`,
      label: "Build category content clusters →",
      external: true
    }
  ],

  alternatives_replacements: [
    {
      href: `${BASE_URL}/learning-center/improve-ai-buyer-journey-visibility`,
      label: "Improve alternatives visibility →",
      external: true
    },
    {
      href: `${BASE_URL}/learning-center/competitive-positioning`,
      label: "Improve competitive positioning →",
      external: true
    },
    {
      href: `${BASE_URL}/learning-center/comparison-pages`,
      label: "Create alternative/comparison pages →",
      external: true
    }
  ],

  comparisons: [
    {
      href: `${BASE_URL}/learning-center/ai-comparison-content`,
      label: "Win comparison queries →",
      external: true
    },
    {
      href: `${BASE_URL}/learning-center/comparison-pages`,
      label: "Create comparison pages →",
      external: true
    },
    {
      href: `${BASE_URL}/learning-center/improve-ai-buyer-journey-visibility`,
      label: "Improve buyer journey visibility →",
      external: true
    }
  ],

  use_case_fit: [
    {
      href: `${BASE_URL}/learning-center/use-cases-and-proof`,
      label: "Add use cases & proof →",
      external: true
    },
    {
      href: `${BASE_URL}/learning-center/improve-ai-buyer-journey-visibility`,
      label: "Improve use-case visibility →",
      external: true
    },
    {
      href: `${BASE_URL}/learning-center/authority-signals`,
      label: "Strengthen authority signals →",
      external: true
    }
  ],

  pain_point_led: [
    {
      href: `${BASE_URL}/learning-center/improve-ai-buyer-journey-visibility`,
      label: "Improve pain-point visibility →",
      external: true
    },
    {
      href: `${BASE_URL}/learning-center/ai-recommendation-content`,
      label: "Improve recommendation inclusion →",
      external: true
    },
    {
      href: `${BASE_URL}/learning-center/use-cases-and-proof`,
      label: "Connect solutions to buyer needs →",
      external: true
    }
  ],

  purchase_shortlist: [
    {
      href: `${BASE_URL}/learning-center/improve-ai-buyer-journey-visibility`,
      label: "Improve purchase-stage visibility →",
      external: true
    },
    {
      href: `${BASE_URL}/learning-center/ai-recommendation-content`,
      label: "Improve recommendation inclusion →",
      external: true
    },
    {
      href: `${BASE_URL}/learning-center/authority-signals`,
      label: "Strengthen trust and authority signals →",
      external: true
    }
  ]
};

export function getLearningLinks(stage: string) {
  return learningLinks[stage as keyof typeof learningLinks] || [
    {
      href: `${BASE_URL}/learning-center/improve-ai-buyer-journey-visibility`,
      label: "Improve buyer journey visibility →",
      external: true
    }
  ];
}